import { render, staticRenderFns } from "./MinigameLabel.vue?vue&type=template&id=35eecd8d&scoped=true"
import script from "./MinigameLabel.vue?vue&type=script&lang=js"
export * from "./MinigameLabel.vue?vue&type=script&lang=js"
import style0 from "./MinigameLabel.vue?vue&type=style&index=0&id=35eecd8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35eecd8d",
  null
  
)

export default component.exports